import { combineReducers } from 'redux';

import byId from './byId/reducer';
import byThreadId from './byThreadId/reducer';

export default combineReducers({
  byId,
  byThreadId
});



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/mailThreadMessages/reducer.js
 **/